(ns kyber.events.utils
  {:clj-kondo/config {:linters {:clojure.core/tap> {:level :off}}}}
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]
            ;; [kyber.interceptors.spec :refer [check-spec-interceptor]]
            [kyber.interceptors.event-spec :refer [event-spec-interceptor]]
            [kyber.feature-flags :refer [feature-enabled?]]))

(defn add-auth
  "Adds authentication to the headers"
  ([db]
   (add-auth db {}))
  ([db headers]
   (let [^js session (get-in db [:session :cognito-session])]
     (if session
       (assoc headers :Authorization (-> session .getIdToken .getJwtToken))
       headers))))

(defn base-uri
  [db route]
  (let [base-uri (get-in db [:configuration :kyber-base-url])]
    (when (nil? base-uri)
      (throw (js/Error. "Missing base-uri from configuration state")))

    ;; If the request is coming from localhost we want to strip off the
    ;; service name since API gateway does this for us when proxying
    ;; requests to corresponding services.
    (if (re-find #"^http://localhost" base-uri)
      (str base-uri
           "/"
           (str/join
            "/"
            (-> route
                (str/split #"/")
                rest
                rest)))
      (str base-uri route))))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Override re-frame event handlers
;;
;; https://github.com/Day8/re-frame/blob/master/docs/FAQs/GlobalInterceptors.md
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(defn kyber-event-db-wrapper
  "Wraps re-frame/reg-event-db to add global interceptors"
  [global-interceptors]
  (fn kyber-event-db*
    ([id handler]
     (kyber-event-db* id nil handler))
    ([id interceptors handler]
     (re-frame/reg-event-db
      id
      (conj [global-interceptors] interceptors)
      handler))))

(defn kyber-event-fx-wrapper
  "Wraps re-frame/reg-event-fx to add global interceptors"
  [global-interceptors]
  (fn kyber-event-fx*
    ([id handler]
     (kyber-event-fx* id nil handler))
    ([id interceptors handler]
     (re-frame/reg-event-fx
      id
      (conj [global-interceptors] interceptors)
      handler))))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Interceptors
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def trace-re-frame-events-interceptor
  (re-frame/->interceptor
   :id     :trace-re-frame-events
   :before (fn [context]
             (when (feature-enabled? :trace-events)
               (let [[event-name] (re-frame/get-coeffect context :event)]
                 (js/console.log "[re-frame event]" event-name)))
             context)))

(def check-spec-interceptor*
  ;; NOTE: Until we migrate 100% over to kyber-db this will cause a lot of noise.
  (when ^boolean js/goog.DEBUG
    #_check-spec-interceptor
    nil))

(def event-spec-interceptor*
  (when ^boolean js/goog.DEBUG
    event-spec-interceptor))

(def global-interceptors
  [trace-re-frame-events-interceptor])

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Kyber Event Handlers
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def kyber-event-db
  (kyber-event-db-wrapper global-interceptors))

(def kyber-event-fx
  (kyber-event-fx-wrapper global-interceptors))

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Kyber Side-Effects
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(re-frame/reg-fx :tap> #(tap> %))
